import React from "react";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import { numberFormat, moneyFormat, moneyFormatCents } from "./format";
import { getTeam, pickValue } from "./utils";
import Auth from "routes/Auth";

const UnitCosts1 = ({
  competitiveAnalysis,
  teams,
  teamId,
  competitionMetrics
}) => {
  const data = competitiveAnalysis || competitionMetrics;
  const field = "Average Unit Cost";
  const team = getTeam(teamId, data);
  const unitsProduced = team["Units Produced"];
  const averageUnitCost = team[field];
  const totalProductionCosts = unitsProduced * averageUnitCost;

  return (
    <OnePanelChart
      title="Unit Costs"
      chartTitle="Average Unit Cost ($)"
      data={pickValue(teams, data, field)}
      prefix="$"
      teams={teams}
      vertical
    >
      <Text>
        In this round, the Head of Operations produced{" "}
        {numberFormat(unitsProduced)} units at a total production costs of{" "}
        {moneyFormat(totalProductionCosts)}, which resulted in product unit
        costs of {moneyFormatCents(averageUnitCost)}. Your unit costs may vary
        if you have any inventory remaining from prior rounds.
      </Text>
      <Text>What drives your production costs?</Text>
    </OnePanelChart>
  );
};

export default UnitCosts1;



// WEBPACK FOOTER //
// ./src/components/analysis/UnitCosts1.js